import React, { createContext, useEffect, useReducer } from 'react'
import statisticsReducer from './statisticsReducer'
import { firestore } from '../../services/firebase'
import { SET_STATISTICS } from '../types'

import { doc, getDoc } from 'firebase/firestore'

const StatisticsContext = createContext()

const StatisticsState = ({ children }) => {
  const initialState = {
    statistics: {},
    statisticsLoaded: false,
  }

  const [state, dispatch] = useReducer(statisticsReducer, initialState)

  useEffect(() => {
    fetchStatistics()
  }, [])

  const fetchStatistics = async () => {
    const statisticsSnapshot = await getDoc(doc(firestore, "aggregates/statistics"))
    const statisticsData = statisticsSnapshot.exists() ? statisticsSnapshot.data() : {}
    dispatch({ type: SET_STATISTICS, payload: statisticsData })
  }

  return (
    <StatisticsContext.Provider value={{
      statistics: state.statistics,
      statisticsLoaded: state.statisticsLoaded,
    }}>
      {children}
    </StatisticsContext.Provider>
  )
}

export default StatisticsState
export { StatisticsContext }
